module.exports = __webpack_public_path__ + "img/hat.87756382.svg";